<div>

  <h1>Demo SSO SAP OIDC flow</h1>
  <div>
    <br />
  </div>

  @if (code) {

  <div style="border: 1px solid #ccc; box-shadow: 1;padding: 20px">
    <div>
      <h4>CODE:</h4> {{code}}
    </div>
  </div>
  } @else {
  <app-button
    variant="primary">
    <a
      href="https://fidm.eu1.gigya.com/oidc/op/v1.0/4_nkLebH6jU3JKIkAh4JWHow/authorize?scope=openid%20email%20profile%20b2b%20uid&response_type=code&client_id=GaftyKBFGHZDmcWKVQ-J2aAr&redirect_uri=https%3A%2F%2Fdiro7160yxgk4.cloudfront.net%2Fcallback">Test
      flow</a>
  </app-button>

  }
</div>